import { useQuery } from '@apollo/client'
import SEARCH_SUPPLIERS from '@/gf/queries/users'
import { User } from '../../types'

interface SearchSuppliersData {
  searchSuppliers: User[]
}

const useSuppliers = () => {
  const { loading, data } = useQuery<SearchSuppliersData>(SEARCH_SUPPLIERS, {
    variables: { value: '' },
    fetchPolicy: 'no-cache',
  })

  if (loading || !data) return []

  return data?.searchSuppliers || []
}

export default useSuppliers
